// extracted by mini-css-extract-plugin
module.exports = {"Title":"style_Title__3fDZY","Heading":"style_Heading__1BhAm","Link":"style_Link__54HRN","List":"style_List__2CbJY","Offer":"style_Offer__10_Gm"};